import {
  css, type SerializedStyles,
} from '@emotion/react';
import { forwardRef } from 'react';
import { Stack } from '~/_shared/baseComponents/layout/stack.component';
import {
  LoaderComponent, type LoaderType,
} from '~/_shared/baseComponents/loaders';
import { OverlayComponent } from './overlay.component';

type OverlayLoaderProps = Readonly<{
  className?: string;
  loaderSize?: number;
  message?: string;
  spinnerStyle?: SerializedStyles;
  loaderType?: LoaderType;
}>;

const contentStyle = css({
  alignItems: 'center',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
});

export const OverlayLoaderComponent = forwardRef<HTMLDivElement, OverlayLoaderProps>((props, ref) => {
  const size = props.loaderSize ?? 60;

  return (
    <OverlayComponent className={props.className} ref={ref}>
      <Stack css={contentStyle} gap={8}>
        <LoaderComponent
          css={props.spinnerStyle}
          size={size}
          type={props.loaderType}
        />
        {props.message && <span>{props.message}</span>}
      </Stack>
    </OverlayComponent>
  );
});
